export const ROLES = {
    'ALL': [1, 2, 3, 4],
    'SUPER_ADMIN': 1,
    'ADMIN': 2,
    'COLABORATOR': 3,
    'COMMUNITY_MANAGER': 4,
};